import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { map, mergeMap } from "rxjs/operators";
import { Observable, forkJoin } from 'rxjs';
import * as _ from 'lodash';
import { FileService } from 'mapfre-auditlib';

@Injectable({
  providedIn: 'root'
})

export class DealComitteeService {

  className = 'DealComitteeService'

  constructor(private http: HttpClient, private fileService: FileService) { }

  /*
  * Deal Comittees
  */
  getAllDealComittees(): any {
    return this.http.get(environment.base_URL + "/deal-comittees")
  }

  getDealComitteeById(id): Observable<any> {
    return this.http.get<any>(environment.base_URL + `/deal-comittees/${id}`);
  }

  newDealComittee(assessment): Observable<any[]> {
    return this.http.post<any[]>(environment.base_URL + "/deal-comittees", assessment);
  }

  newDealComitteeWithFiles(assessment): Observable<any[]> {
    // PRE FILES INI
    let filesToUpload = _.remove(_.get(assessment, 'documents'), (f) => f instanceof File);
    // PRE FILES END
    //CHECK IF THERE ARE NEW FILES
    if (!_.isEmpty(filesToUpload)) {
      return this.newDealComittee(assessment).pipe(mergeMap((res: any) => {
        let observables = _.map(filesToUpload, (f) => this.fileService.upload(f, 'dealComittee', res));
        return forkJoin(observables).pipe(map(resultFiles => {
          return res;
        }));
      }))
    }
    else {
      return this.newDealComittee(assessment)
    }
  }

  updateDealComittee(assessment, id) {
    return this.http.put<any[]>(environment.base_URL + `/deal-comittees/${id}`, assessment)
  }

  updateDealComitteeWithFiles(assessment, id): Observable<any[]> {
    // PRE FILES INI
    let tempList = [];
    _.forEach(_.get(assessment, 'documents'), (doc: any) => {
      if(!doc.idtSqn){
        tempList.push(doc)
      }
    })
    let filesToUpload = _.remove(tempList, (f) => f instanceof File);
    // PRE FILES END
    //CHECK IF THERE ARE NEW FILES
    if (!_.isEmpty(filesToUpload)) {
      return this.updateDealComittee(assessment, id).pipe(mergeMap((res: any) => {
        let observables = _.map(filesToUpload, (f) => this.fileService.upload(f, 'dealComittee', res));
        return forkJoin(observables).pipe(map(resultFiles => {
          return res;
        }));
      }))
    }
    else {
      return this.updateDealComittee(assessment, id);
    }
  }

  deleteDealComittee(id): Observable<any> {
    return this.http.delete<any>(environment.base_URL + `/deal-comittees/${id}`);
  }

  /*
  * Deal Comittees Entrace
  */
  getAllDealComitteesEntraces(dealComitteeId): any {
    return this.http.get(environment.base_URL + `/deal-comittees/${dealComitteeId}/entrance`)
  }

  getDealComitteeEntraceById(dealComitteeId, dealComitteeEntraceId): Observable<any> {
    return this.http.get<any>(environment.base_URL + `/deal-comittees/${dealComitteeId}/entrance/${dealComitteeEntraceId}`);
  }

  newDealComitteeEntrace(assessment, dealComitteeId): Observable<any[]> {
    return this.http.post<any[]>(environment.base_URL + `/deal-comittees/${dealComitteeId}/entrance`, assessment);
  }

  newDealComitteeEntraceWithFiles(assessment, dealComitteeId): Observable<any[]> {
    // PRE FILES INI
    let filesToUpload = _.remove(_.get(assessment, 'documents'), (f) => f instanceof File);
    // PRE FILES END
    //CHECK IF THERE ARE NEW FILES
    if (!_.isEmpty(filesToUpload)) {
      return this.newDealComitteeEntrace(assessment, dealComitteeId).pipe(mergeMap((res: any) => {
        let observables = _.map(filesToUpload, (f) => this.fileService.upload(f, 'dealComitteeEntrace', res));
        return forkJoin(observables).pipe(map(resultFiles => {
          return res;
        }));
      }))
    }
    else {
      return this.newDealComitteeEntrace(assessment, dealComitteeId)
    }
  }

  updateDealComitteeEntrace(assessment, dealComitteeId, dealComitteeEntraceId) {
    return this.http.put<any[]>(environment.base_URL + `/deal-comittees/${dealComitteeId}/entrance/${dealComitteeEntraceId}`, assessment)
  }

  updateDealComitteeEntraceWithFiles(assessment, dealComitteeId, dealComitteeEntraceId): Observable<any[]> {
    // PRE FILES INI
    let tempList = [];
    _.forEach(_.get(assessment, 'documents'), (doc: any) => {
      if(!doc.idtSqn){
        tempList.push(doc)
      }
    })
    let filesToUpload = _.remove(tempList, (f) => f instanceof File);
    // PRE FILES END
    //CHECK IF THERE ARE NEW FILES
    if (!_.isEmpty(filesToUpload)) {
      return this.updateDealComitteeEntrace(assessment, dealComitteeId, dealComitteeEntraceId).pipe(mergeMap((res: any) => {
        let observables = _.map(filesToUpload, (f) => this.fileService.upload(f, 'dealComitteeEntrace', res));
        return forkJoin(observables).pipe(map(resultFiles => {
          return res;
        }));
      }))
    }
    else {
      return this.updateDealComitteeEntrace(assessment, dealComitteeId, dealComitteeEntraceId);
    }
  }

  deleteDealComitteeEntrace(dealComitteeId, dealComitteeEntraceId): Observable<any> {
    return this.http.delete<any>(environment.base_URL + `/deal-comittees/${dealComitteeId}/entrance/${dealComitteeEntraceId}`);
  }

}

